import React from 'react';
import Link from 'next/link';

const Footer: React.FC = () => {
  return (
    <footer
      style={{
        borderTop: '1px solid rgba(255,255,255,0.07)',
        padding: '40px 0',
        background: 'rgba(15, 15, 15, 0.8)',
        position: 'relative',
        zIndex: 10,
      }}
    >
      <div
        className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-4"
      >
        <span
          style={{
            fontFamily: 'Plus Jakarta Sans, sans-serif',
            fontWeight: 700,
            fontSize: '16px',
            letterSpacing: '-0.02em',
            color: '#f5f5f5',
          }}
        >
          VideoPortfolio
        </span>

        <div className="flex items-center gap-6">
          {[
            { href: '/homepage', label: 'Work' },
            { href: '/contact', label: 'Contact' },
            { href: '#', label: 'Privacy' },
            { href: '#', label: 'Terms' },
          ].map((link) => (
            <Link
              key={link.label}
              href={link.href}
              style={{
                fontFamily: 'DM Sans, sans-serif',
                fontWeight: 500,
                fontSize: '14px',
                color: '#6b7280',
                textDecoration: 'none',
                transition: 'color 0.2s ease',
              }}
              onMouseEnter={(e) =>
                ((e.currentTarget as HTMLElement).style.color = '#f5f5f5')
              }
              onMouseLeave={(e) =>
                ((e.currentTarget as HTMLElement).style.color = '#6b7280')
              }
            >
              {link.label}
            </Link>
          ))}
        </div>

        <span
          style={{
            fontFamily: 'DM Sans, sans-serif',
            fontWeight: 400,
            fontSize: '13px',
            color: '#4b5563',
          }}
        >
          © 2026 VideoPortfolio
        </span>
      </div>
    </footer>
  );
};

export default Footer;